import Vue from "vue";
import VueRouter from "vue-router";

// import index from "./middleware/index";
import VueRouteMiddleware from "vue-route-middleware";
Vue.use(VueRouter);

function load(componentName) {
  return () => import(`@/components/pages/${componentName}`);
}

const router = new VueRouter({
  mode: "hash",
  routes: [
    {
      path: "/",
      meta: {
        middleware: (to, from, next) => {
          next("/mn");
        }
      }
    },
    {
      path: "/:lang",
      name: "index",
      component: {
        render(c) {
          return c("router-view");
        }
      },
      children: [
        {
          path: "",
          name: "local-index",
          component: load("Home")
        },
        {
          path: "greetings",
          name: "greetings",
          component: load("Greeting")
        },
        {
          path: "goals",
          name: "goal",
          component: load("Goal")
        },
        {
          path: "news",
          name: "news",
          component: load("News")
        },
        {
          path: "news/:newsId",
          name: "SingeNews",
          component: load("SingleNews")
        },
        {
          path: "categorypage/:categoryId",
          component: load("CategoryPage")
        },
        {
          path: "membership",
          name: "membership",
          component: load("Membership")
        },
        {
          path: "services",
          name: "services",
          component: load("Services")
        },
        {
          path: "contact",
          name: "contact",
          component: load("Contact")
        }
      ]
    }
  ]
});
router.beforeEach(VueRouteMiddleware());
export default router;
